import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {PictureViewComponent} from './picture-view.component';
import {PictureService} from './picture.service';
import {PictureDatatableComponent} from './picture-datatable.component';
import {PictureFormComponent} from './picture-form.component';
import {FileModule} from '../file/file.module';
import {Picture} from './picture.model';

@NgModule({
  declarations: [
    PictureDatatableComponent,
    PictureViewComponent,
    PictureFormComponent,
  ],
  exports: [
    PictureDatatableComponent,
    PictureViewComponent,
    PictureFormComponent,
  ],
  imports: [
    SharedModule,
    FileModule
  ],
  providers: [
    PictureService,
    Picture
  ]
})
export class PictureModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture.module.ts